<div class="row fields-group" *ngFor="let section of availableTransformations">
  <div class="col">
  <label class="d-block list-title">{{ section.name | translate }}</label>
  <div *ngIf="section.allowMultiple;then multiple_select else single_select"></div>
  <ng-template #multiple_select>
      <mat-selection-list [(ngModel)]="section.selected" (selectionChange)="onSelectChange($event, section)">
        <div cdkDropList (cdkDropListDropped)="drop($event, section)">
          <span *ngFor="let transformation of section.transformations" cdkDrag>
            <mat-list-option [value]="transformation.value">
              <div>
                <i cdkDragHandle class="move fa fa-arrows-alt transition"></i>
                {{transformation.name}}
              </div>
            </mat-list-option>
            <span *cdkDragPreview>
              {{transformation.name}}
            </span>
          </span>
        </div>
      </mat-selection-list>
    </ng-template>
    <ng-template #single_select>
      <mat-selection-list [(ngModel)]="section.selected" (selectionChange)="onSelectChange($event, section)">
        <span *ngFor="let transformation of section.transformations">
          <mat-list-option [value]="transformation.value">
            <div>{{transformation.name}}</div>
          </mat-list-option>
        </span>
      </mat-selection-list>
    </ng-template>
  </div>
</div>
